import { Outlet, useParams } from 'react-router'
import RouteTabs from '@/components/common/RouteTabs'
import type { RouteTabItem } from '@/components/common/RouteTabs'

export default function AgentLayout() {
  const { clientId } = useParams<{ clientId: string }>()
  if (!clientId) return null

  const base = `/workspace/clients/${clientId}`
  const tabs: RouteTabItem[] = [
    { label: 'Overview', href: `${base}/agent` },
    { label: 'Setup', href: `${base}/configure` },
    { label: 'Chat', href: `${base}/chat` },
  ]

  return (
    <RouteTabs tabs={tabs}>
      <Outlet />
    </RouteTabs>
  )
}
